export default function Logo({ fontSize = '22px', fontFamily = 'FontBold', }) {
  return (
    <h6
      className="mNoMargin"
      style={{
        fontSize,
        fontFamily,
      }}
    >
      KUMBUKA
    </h6>
  )
}